/** `sessionStorage`, or null where reading it throws (blocked site data, SSR). */
export function sessionStore(): Storage | null {
  try {
    return typeof window === "undefined" ? null : window.sessionStorage;
  } catch {
    return null;
  }
}
